import { Component } from 'react';
import { History, Location } from 'history';
import { Match, ValOrFunc, ToProps, NavParams, createNavParams } from './utils';
import { InjectApp, Core } from '@core';

export type NavProviderPropsTyped<P> = {
  app?: Core;
  to: ToProps;
  match?: ValOrFunc<Match>;
  replace?: boolean;
  // render
  renderChild: (params: NavParams) => JSX.Element;
  noSubscribe?: boolean;
};

export type NavProviderProps = NavProviderPropsTyped<{}>;

export type NavProviderState = {
  location: Location;
};

@InjectApp<typeof NavProvider, {}>()
export class NavProvider extends Component<NavProviderProps, {}> {

  static displayName: string = 'NavProvider';

  private history: History;  
  private unlisten: () => void;
  private isUnmounted: boolean = false;

  constructor(props: NavProviderProps) {
    super(props);
    if (props.app) {
      this.history = props.app.getHistory();
    }
  }

  componentDidMount() {
    if (this.props.noSubscribe !== true) {
      this.unlisten = this.history.listen(() => {
        this.update();
      });
    }
  }

  componentWillReceiveProps(nextProps: NavProviderProps): void {
    if (this.props.noSubscribe !== nextProps.noSubscribe) {
      if (nextProps.noSubscribe && this.unlisten) {
        this.unlisten();
      } else {
        this.unlisten = this.history.listen(() => {
          this.update();
        });
      }
    }
  }

  componentWillUnmount(): void {
    this.isUnmounted = true;
    if (this.unlisten) {
      this.unlisten();
    }
  }

  render(): JSX.Element {
    const { renderChild, to, replace, match } = this.props;
    const location: Location = this.history.location;
    const childParams: NavParams = createNavParams(
      to,
      this.history,
      location,
      replace,
      match,
    );

    return renderChild(childParams);
  }

  private update(): void {
    if (this.isUnmounted === false) {
      this.forceUpdate();
    }
  }

}


// WEBPACK FOOTER //
// src/app/src/components/Link/NavProvider.tsx